import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    token: '',
    avatar: '',
    introduction: '',
    roles: [],
    loginPopupVisible: false,
  },
  mutations: {
    // 设置登录弹窗可见性
		SET_LOGIN_POPUP_VISIBLE(state, visible) {
			console.log('SET_LOGIN_POPUP_VISIBLE 执行了', visible);
			
      state.loginPopupVisible = visible;
    },
  },
  actions: {
    // 打开登录弹窗
    showLoginPopup({ commit }) {
      commit('SET_LOGIN_POPUP_VISIBLE', true);
    },
    // 关闭登录弹窗
    hideLoginPopup({ commit }) {
      commit('SET_LOGIN_POPUP_VISIBLE', false);
    },
  },
});
